/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getCachedSuggestions} from '../api'

 export const useQueryGetCachedSuggestions = createReactQueryHook('getCachedSuggestions', getCachedSuggestions)
